// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3bTl5","col":"styles_col__O5rbE"};